const validAllowedCharacters = [
  '~',
  '`',
  '!',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '(',
  ')',
  '_',
  '-',
  '+',
  '=',
  '{',
  '[',
  '}',
  ']',
  '|',
  '\\',
  ':',
  ';',
  "'",
  '"',
  '<',
  ',',
  '>',
  '.',
  '?',
  '/',
];

export default validAllowedCharacters;
